import React, { useEffect, useMemo, useState } from 'react';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import modelChoiceStore from '../model-choice/store';
import { SVGPureIcon } from '@/ui';
import userStore from '@/store/user';
import inputTypeStore from '@/components/input-file/input-type';
import MultiKnowledgeModal from './MultiKnowledgeModal';
import kbStore from '@/components/kb-node-tree/kb-store';
import type { UserInfo } from '@/common/login-info';

const MultiKnowledge = (props: {
  disabled: boolean;
  title: string;
  className: string;
  disabledToolTip: boolean;
  userInfo: UserInfo;
  defaultOpen: boolean;
}) => {
  const [modalOpen, toggleModal] = useState(false);

  const [modalKey, updateModalKey] = useState(1);

  const onCancel = () => {
    toggleModal(false);
    updateModalKey(modalKey + 1);
  };

  const onConfirm = () => {
    onCancel();
  };

  const enabled = useMemo(() => {
    if (props.disabled) {
      return false
    }
    return modelChoiceStore.currentModel?.model_type === 9999 && modelChoiceStore.currentModel?.rag_recall == 1
  }, [props.disabled, modelChoiceStore.currentModel])

  useEffect(() => {
    const urlObj = new URL(window.location.href);
    if (urlObj.searchParams.get('kbId') && modelChoiceStore.currentModel?.rag_recall == 1) {
      toggleModal(true)
    }
    urlObj.searchParams.delete('kbId');
    urlObj.searchParams.delete('containChildren');
    history.pushState({}, '', urlObj.href);
  }, []);
  return (
    <>
      <div>
        <Tooltip title={enabled ? props.title : null}>
          <button
            className={[
              'flex items-center',
              'rounded-full cursor-pointer text-primary',
              props.disabledToolTip || !!inputTypeStore.tempFile?.length || !enabled ? 'opacity-30' : '',
            ].join(' ')}
            disabled={!enabled}
            onClick={() => {
              if (!userStore.isUser) {
                userStore.gotoLogin();
                return;
              }
              toggleModal(true);
            }}
          >
            <SVGPureIcon name="knowledge" className="size-20px" />
          </button>
        </Tooltip>
        <MultiKnowledgeModal
          key={modalKey}
          store={kbStore}
          open={modalOpen}
          cancel={onCancel}
          confirm={onConfirm}
          userInfo={props.userInfo}
        />
      </div>
    </>
  );
};

export default observer(MultiKnowledge);
